// styles.ts
import styled from "styled-components";
import { TextField as MuiTextField } from "@mui/material";

export const Container = styled.div<{ alert: boolean }>`
  position: relative;
  overflow: hidden;
  margin-top: 75px;
  width: 300px;
  display: flex; /* 플렉스 컨테이너로 변경 */
  flex-direction: column; /* 하위 요소들을 세로 방향으로 배치 */
  justify-content: center; /* 세로축 중앙 정렬 */
  align-items: center; /* 가로축 중앙 정렬 */
  border: ${({ alert }) => (alert ? `1px solid red` : `none`)};
  border-radius: 8px;
`;

// 섹션 위에 이미지 수정
export const TitleHighlight = styled.div<{ image: string }>`
  background-image: url(${({ image }) => image});
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  width: 70px;
  height: 70px;
  z-index: 20;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;

export const PlusIcon = styled.img`
  width: 70px;
  height: 40px;
  cursor: pointer;
  margin-bottom: 10px;

  &:hover {
    opacity: 0.5;
  }
`;

export const HiddenInput = styled.input`
  display: none;
  cursor: pointer;
  z-index: 1;
  &:hover {
    opacity: 0.5;
  }
`;

export const DeleteButton = styled.button`
  // margin-left: -5px;
  // margin-top: -15px;
  background-color: rgba(255, 255, 255, 0.7);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
`;

export const LinkInput = styled(MuiTextField)`
  div {
    font-size: 14px;
    width: 300px;
    height: 10px;
    background-color: #f7f9fd;
    padding: 15px 8px;
    border-radius: 6px;

    input {
      text-align: center;
    }

    ::before {
      border-bottom: ${({ theme }) => `0px solid ${theme.colors.GREY_HEAVY}`} !important;
    }

    ::after {
      border-bottom: ${({ theme }) => `2px solid ${theme.colors.BLUE_HEAVY}`};
    }
  }
`;

export const Label = styled.label`
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;

  &::after {
    content: "브랜드 로고 추가            추천: 배경없는 png 파일";
    width: 120px;
    position: absolute;
    top: 15px;
    left: 55%;
    transform: translateX(-50%);
    background-color: gray;
    color: #fff;
    padding: 3px 5px;
    border-radius: 5px;
    white-space: pre-wrap; /* 줄 바꿈을 허용 */
    opacity: 0;
    font-size: 12px;
    pointer-events: none;
    transition: opacity 0.3s;
    z-index: 100;
  }

  &:hover::after {
    opacity: 1;
  }
`;
